import { createMRTColumnHelper, MRT_ColumnDef } from "material-react-table";
import EntityReferenceComponent from "../../components/entitiesReferences/EntityReferenceComponent";
import {
  EntityWithMetadataTableSuffixColumns,
  createConnectionFilterSpec,
} from "./EntityUtils";
import type { FilterSpec } from "../../hooks/useServerFilters";
import {
  PERSON_CONNECTION_TYPE_LABELS,
  PERSON_IMPLIES_CONNECTION_TYPE_LABELS,
  PersonConnection,
  SystemPersonConnectionTypes,
  SystemPersonImpliesConnectionTypes,
} from "../../types/personConnection";

const columnHelper = createMRTColumnHelper<PersonConnection>();

export const personConnectionColumns: MRT_ColumnDef<PersonConnection, any>[] = [
  columnHelper.accessor("fromDoc", {
    header: "Person",
    enableColumnFilter: false,
    Cell: ({ cell }) =>
      cell.getValue() ? (
        <EntityReferenceComponent entity={cell.getValue()} />
      ) : (
        "-"
      ),
  }),
  columnHelper.accessor("toDoc", {
    header: "Connected To Person",
    enableColumnFilter: false,
    Cell: ({ cell }) =>
      cell.getValue() ? (
        <EntityReferenceComponent entity={cell.getValue()} />
      ) : (
        "-"
      ),
  }),
  columnHelper.accessor("system_person_connection_type", {
    header: "Person Connection Type",
    Cell: ({ cell }) =>
      PERSON_CONNECTION_TYPE_LABELS[
        cell.getValue<SystemPersonConnectionTypes>()
      ] || "-",
  }),
  ...EntityWithMetadataTableSuffixColumns,
];

export const personConnectionFilterSpec: FilterSpec = createConnectionFilterSpec({
  system_person_connection_type: { kind: "string" },
});

export const personImpliesConnectionColumns: MRT_ColumnDef<
  PersonConnection,
  any
>[] = [
  columnHelper.accessor("fromDoc", {
    header: "Teacher/Parent",
    enableColumnFilter: false,
    Cell: ({ cell }) =>
      cell.getValue() ? (
        <EntityReferenceComponent entity={cell.getValue()} />
      ) : (
        "-"
      ),
  }),
  columnHelper.accessor("toDoc", {
    header: "Disciple/Child",
    enableColumnFilter: false,
    Cell: ({ cell }) =>
      cell.getValue() ? (
        <EntityReferenceComponent entity={cell.getValue()} />
      ) : (
        "-"
      ),
  }),
  columnHelper.accessor("system_person_connection_type", {
    header: "Connection",
    Cell: ({ cell }) =>
      PERSON_IMPLIES_CONNECTION_TYPE_LABELS[
        cell.getValue<SystemPersonImpliesConnectionTypes>()
      ] || "-",
  }),
  ...EntityWithMetadataTableSuffixColumns,
];
